import { ACCESS_TOKEN, API_BASE_URL } from "constants/index";

export function generetePresentations(obj) {
  return fetch(API_BASE_URL + "/presentations/generate", {
    method: "POST",
    headers: { authorization: localStorage.getItem(ACCESS_TOKEN) },
    body: obj,
  })
    
}
export function checkPresentationStatus(generationId) {
  const endpoint = API_BASE_URL + `/presentations/${generationId}/status`;
  return fetch(endpoint, {
    method: "GET",
    headers: { authorization: localStorage.getItem(ACCESS_TOKEN) },
  })
    
}
